import { Navigate, Outlet, useLocation } from "react-router-dom"
import Header from "../components/header";
import Footer from "../components/footer";
import Helpers from "../services/helpers";
import SideBar from "../components/sideMenu";

const ProtectedLayout = () => {
    const location = useLocation();
    const { pathname } = location;
    const splitLocation = pathname.split("/");
    let pageName = splitLocation[1];
    const Token = Helpers.getTokenData();
    if (!Token?.access_token) {
        return <Navigate to="/login" replace />
    }

    return (
        <>
            {/* <Header />
            <div style={{ marginBottom: '95px', marginTop: '70px' }}>
                <Outlet />
            </div>
            {pageName !== 'mines' &&
                <Footer />
            } */}

            <section className='sideBarSection'>
                <SideBar />
                <section className='mainContent'>
                    <Header />
                    <div className="webCastomMargen">
                        <Outlet />
                    </div>
                    <div>
                        {pageName !== 'mines' && pageName !== 'aviator' && pageName !== 'plinko' &&
                            <Footer />
                        }
                    </div>
                </section>
            </section>
        </>
    )
}

export default ProtectedLayout;